import { motion } from 'motion/react'
import { customerMotionTransition } from '../customer-area'
import type { ActiveFilterChip } from './ordersListSectionTypes'

type OrdersActiveFilterChipsProps = {
  reducedMotion: boolean
  chips: ActiveFilterChip[]
}

export const OrdersActiveFilterChips = ({ reducedMotion, chips }: OrdersActiveFilterChipsProps) => (
  <motion.div
    initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 4 }}
    animate={reducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
    exit={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 4 }}
    transition={customerMotionTransition}
    className="mt-3 flex flex-wrap items-center gap-2"
  >
    {chips.map((chip) => (
      <motion.button
        key={chip.id}
        type="button"
        onClick={chip.onRemove}
        whileTap={reducedMotion ? undefined : { scale: 0.985 }}
        transition={customerMotionTransition}
        className="ca-theme-transition inline-flex items-center gap-1 rounded-full border border-(--color-border-strong) bg-(--color-bg-surface-muted) px-2.5 py-1 text-xs font-semibold text-(--color-text-secondary) hover:border-(--color-border-default) hover:bg-(--color-bg-card) hover:text-(--color-text-primary)"
      >
        <span>{chip.label}</span>
        <span aria-hidden>x</span>
      </motion.button>
    ))}
  </motion.div>
)
